import Log from './Logger';

import { query } from './api-core';

function getEwbReqId(resp: any) {
    return resp?.headers?.['ricoh-ewb-request-id'] ?? '-';
}

type FeatureToggle = {
    id: string;
}

export class GetFeatureToggleError extends Error {
    status: number;
    headers: any;
    constructor(message: string, status: number, headers: any) {
        super(message);
        this.name = 'GetFeatureToggleError';
        this.status = status;
        this.headers = headers;
    }
}

export async function getFeatureToggle(): Promise<FeatureToggle[]> {
    const logger = Log.getLogger();

    logger.api.info('Lantana-API', 'Start to request: allWebUIFeatureSetting');

    const resp = await query<FeatureToggle[]>('allWebUIFeatureSetting', ['id']);
    if (resp.data.errors && resp.data.errors.length && resp.data.errors.length > 0) {
        const msg = `Failed to execute allWebUIFeatureSetting API: id=${getEwbReqId(resp)}`;
        logger.api.error('Lantana-API', msg, resp.headers);
        throw new GetFeatureToggleError(msg, resp.status, resp.headers);
    }

    logger.api.info('Lantana-API', 'Succeed to request: allWebUIFeatureSetting', resp.headers);

    return resp.data.data.allWebUIFeatureSetting;
}
